module.exports = __webpack_public_path__ + "static/media/img-teams-join-team@3x.cf890ceb.png";